/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, disable, theme } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : ACCOUNT PREFER SELECTOR : STYLES --------------- ++++++++++ */
export default {
    preferselector: {
    	display: 'flex',
        alignItems: 'center',
        border: `solid ${pxToEm(2)} ${theme.color.neutral.light.swatch}`,
        borderRadius: pxToEm(4),
        padding: `${pxToEm(10)} ${pxToEm(20)}`,
        marginTop: pxToEm(20),
        '&.editable-false':{
            extend: disable
        },
        '& .checkbox':{
            marginRight: pxToEm(15),
            '&.active-false': {
                background: theme.color.neutral.light.swatch
            }
        }
    }
}
